/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ volumeText: NonNullable<unknown> }} Wrapped_Period_Scale_LineInputs */

const en_us2_wrapped_period_scale_line = /** @type {(inputs: Wrapped_Period_Scale_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} lifted in total.`)
};

const pt_br2_wrapped_period_scale_line = /** @type {(inputs: Wrapped_Period_Scale_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} levantadas no total.`)
};

const es_419_wrapped_period_scale_line = /** @type {(inputs: Wrapped_Period_Scale_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} levantados en total.`)
};

const pt_pt2_wrapped_period_scale_line = /** @type {(inputs: Wrapped_Period_Scale_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} levantados no total.`)
};

const fr_fr2_wrapped_period_scale_line = /** @type {(inputs: Wrapped_Period_Scale_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Charge totale soulevée : ${i?.volumeText}.`)
};

const de_de2_wrapped_period_scale_line = /** @type {(inputs: Wrapped_Period_Scale_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} insgesamt gestemmt.`)
};

const it_it2_wrapped_period_scale_line = /** @type {(inputs: Wrapped_Period_Scale_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} sollevati in totale.`)
};

/**
* | output |
* | --- |
* | "{volumeText} lifted in total." |
*
* @param {Wrapped_Period_Scale_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_scale_line = /** @type {((inputs: Wrapped_Period_Scale_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Scale_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_scale_line(inputs)
	if (locale === "es-419") return es_419_wrapped_period_scale_line(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_scale_line(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_scale_line(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_scale_line(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_scale_line(inputs)
	return en_us2_wrapped_period_scale_line(inputs)
});
export { wrapped_period_scale_line as "wrapped-period.scale_line" }